import { useRoutes } from "react-router-dom";
import {
  authRoutes,
  adminRoutes,
  profRoutes,
  etudiantRoutes,
} from "./Routes/routes";
import {  ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

function AdminRoutes({ useRoutes, routes }) {
  const routeResult = useRoutes(routes);
  return routeResult;
}
function ProfRoutes({ useRoutes, routes }) {
  const routeResult = useRoutes(routes);
  return routeResult;
}
function EtudiantRoutes({ useRoutes, routes }) {
  const routeResult = useRoutes(routes);
  return routeResult;
}
function AuthRoutes({ useRoutes, routes }) {
  const routeResult = useRoutes(routes);
  return routeResult;
}

function App() {
 
  const navigate = useNavigate();
 


  return (
    <div>
      <AdminRoutes useRoutes={useRoutes} routes={adminRoutes} />
      <ProfRoutes useRoutes={useRoutes} routes={profRoutes} />
      <EtudiantRoutes useRoutes={useRoutes} routes={etudiantRoutes} />
      <AuthRoutes useRoutes={useRoutes} routes={authRoutes} />
      <ToastContainer />
    </div>
  );
}

export default App;
